import Rails from '@rails/ujs';
import { isDevelopment } from './utils/dev';
class Logger {
    constructor() {
        this.init();
    }
    init() {
        const box = document.getElementById('tv-logger');
        if (box)
            return;
        const newBox = document.createElement('div');
        newBox.style.position = 'fixed';
        newBox.style.bottom = '0';
        newBox.style.left = '0';
        newBox.style.width = '50%';
        newBox.style.height = '100px';
        newBox.style.backgroundColor = 'white';
        newBox.style.color = 'black';
        newBox.style.border = '1px solid black';
        newBox.style.zIndex = '1000';
        newBox.style.padding = '10px';
        newBox.style.fontFamily = 'monospace';
        newBox.style.fontSize = '8px';
        newBox.style.whiteSpace = 'pre-wrap';
        newBox.style.wordBreak = 'break-all';
        newBox.style.overflow = 'scroll';
        newBox.dataset.turboPermanent = 'true';
        newBox.id = 'tv-logger';
        document.body.appendChild(newBox);
    }
    log(message) {
        const box = document.getElementById('tv-logger');
        if (!box)
            return;
        box.textContent = `${box.textContent}${new Date().getTime()}: ${message}\n`;
        box.scrollTop = box.scrollHeight;
    }
}
if (window.__fw_app__.tvSession) {
    const logger = new Logger();
    document.addEventListener('wlaRemoteKeyEvent', (event) => {
        const { detail } = event;
        if (detail.action !== 'ACTION_DOWN')
            return;
        const activeElement = document.activeElement;
        if (!activeElement) {
            logger.log('No active element :: focusFirstElement');
            return focusFirstElement();
        }
        if (activeElement instanceof HTMLElement && !activeElement.dataset.tvFocusable) {
            logger.log('Active element is not focusable :: focusFirstElement');
            return focusFirstElement();
        }
        if (detail.key === 'KEYCODE_DPAD_RIGHT') {
            logger.log('KEYCODE_DPAD_RIGHT :: focusNextFocusable');
            focusNextFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_LEFT') {
            logger.log('KEYCODE_DPAD_LEFT :: focusPreviousFocusable');
            focusPreviousFocusable();
        }
        if (detail.key === 'KEYCODE_DPAD_UP') {
            const activeElement = document.activeElement;
            if (!activeElement) {
                logger.log('No active element :: focusPreviousContainer');
                return;
            }
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement)) {
                logger.log('Closest focus container is not an HTMLElement :: focusPreviousContainer');
                return;
            }
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                logger.log('KEYCODE_DPAD_UP :: focusPrevoiusGridFocusable');
                focusPrevoiusGridFocusable();
            }
            else {
                logger.log('KEYCODE_DPAD_UP :: focusPreviousContainer');
                focusPreviousContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_DOWN') {
            const activeElement = document.activeElement;
            if (!activeElement) {
                logger.log('No active element :: focusNextContainer');
                return;
            }
            const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
            if (!(closestFocusContainer instanceof HTMLElement)) {
                logger.log('Closest focus container is not an HTMLElement :: focusNextContainer');
                return;
            }
            if (closestFocusContainer.dataset.tvFocusContainerGrid) {
                logger.log('KEYCODE_DPAD_DOWN :: focusNextGridFocusable');
                focusNextGridFocusable();
            }
            else {
                logger.log('KEYCODE_DPAD_DOWN :: focusNextContainer');
                focusNextContainer();
            }
        }
        if (detail.key === 'KEYCODE_DPAD_CENTER') {
            const activeElement = document.activeElement;
            if (!(activeElement instanceof HTMLElement))
                return;
            activeElement.click();
            if (activeElement instanceof HTMLInputElement && activeElement.form) {
                Rails.fire(activeElement.form, 'submit');
            }
        }
    });
    if (isDevelopment()) {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight' ||
                event.key === 'ArrowLeft' ||
                event.key === 'ArrowUp' ||
                event.key === 'ArrowDown' ||
                event.key === 'Enter') {
                event.preventDefault();
            }
            if (event.key === 'ArrowRight') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_RIGHT',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowLeft') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_LEFT',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowUp') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_UP',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'ArrowDown') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_DOWN',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
            if (event.key === 'Enter') {
                document.dispatchEvent(new CustomEvent('wlaRemoteKeyEvent', {
                    detail: {
                        key: 'KEYCODE_DPAD_CENTER',
                        action: 'ACTION_DOWN',
                    },
                }));
            }
        });
    }
    const getPreviousSibling = (elem, selector) => {
        let sibling = elem.previousElementSibling;
        if (!selector)
            return sibling;
        while (sibling) {
            if (sibling.matches(selector))
                return sibling;
            sibling = sibling.previousElementSibling;
        }
    };
    const getNextSibling = (elem, selector) => {
        let sibling = elem.nextElementSibling;
        if (!selector)
            return sibling;
        while (sibling) {
            if (sibling.matches(selector))
                return sibling;
            sibling = sibling.nextElementSibling;
        }
    };
    const focusPreviousFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const previousElement = getPreviousSibling(activeElement, '[data-tv-focusable]');
        if (previousElement && previousElement instanceof HTMLElement) {
            previousElement.focus();
        }
    };
    const focusNextFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        if (!(activeElement instanceof HTMLElement))
            return;
        const nextElement = getNextSibling(activeElement, '[data-tv-focusable]');
        if (nextElement && nextElement instanceof HTMLElement) {
            nextElement.focus();
        }
    };
    const focusPreviousContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        if (currentFocusContainerIndex === 0)
            return;
        const previousFocusContainer = allFocusContainers[currentFocusContainerIndex - 1];
        if (previousFocusContainer) {
            previousFocusContainer.querySelector('[data-tv-focusable]')?.focus();
            previousFocusContainer.querySelector('[data-tv-focusable].active')?.focus();
        }
    };
    const focusNextContainer = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!closestFocusContainer)
            return;
        const allFocusContainers = document.querySelectorAll('[data-tv-focus-container]');
        const currentFocusContainerIndex = Array.from(allFocusContainers).indexOf(closestFocusContainer);
        if (currentFocusContainerIndex === allFocusContainers.length - 1)
            return;
        const nextFocusContainer = allFocusContainers[currentFocusContainerIndex + 1];
        if (nextFocusContainer) {
            nextFocusContainer.querySelector('[data-tv-focusable]')?.focus();
        }
    };
    const focusPrevoiusGridFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        const gridColumns = closestFocusContainer.dataset.tvFocusContainerGridColumns;
        if (!gridColumns)
            return;
        if (currentFocusableIndex < parseInt(gridColumns))
            return focusPreviousContainer();
        const newFocusElement = allFocusables[currentFocusableIndex - parseInt(gridColumns)];
        if (newFocusElement instanceof HTMLElement) {
            newFocusElement.focus();
        }
    };
    const focusNextGridFocusable = () => {
        const activeElement = document.activeElement;
        if (!activeElement)
            return;
        const closestFocusContainer = activeElement.closest('[data-tv-focus-container]');
        if (!(closestFocusContainer instanceof HTMLElement))
            return;
        const allFocusables = closestFocusContainer.querySelectorAll('[data-tv-focusable]');
        const currentFocusableIndex = Array.from(allFocusables).indexOf(activeElement);
        const gridColumns = closestFocusContainer.dataset.tvFocusContainerGridColumns;
        if (!gridColumns)
            return;
        const newFocusElement = allFocusables[currentFocusableIndex + parseInt(gridColumns)];
        if (newFocusElement instanceof HTMLElement) {
            newFocusElement.focus();
        }
    };
    const focusFirstElement = () => {
        document.querySelector('[data-tv-focusable]')?.focus();
        document.querySelector('.tv-header__tab.active')?.focus();
        document.querySelector('[data-tv-focus-on-turbo-load]')?.focus();
    };
    document.addEventListener('turbo:load', () => {
        const logger = new Logger();
        logger.init();
        focusFirstElement();
    });
}
